import { jsxs as d, Fragment as c, jsx as r } from "react/jsx-runtime";
import "react";
import '../../assets/GridList.css';const i = {
  "grid-list": "_grid-list_17klz_1",
  "grid-list-header": "_grid-list-header_17klz_9",
  "grid-list--1-columns": "_grid-list--1-columns_17klz_13",
  "grid-list--2-columns": "_grid-list--2-columns_17klz_17",
  "grid-list--3-columns": "_grid-list--3-columns_17klz_21",
  "grid-list--4-columns": "_grid-list--4-columns_17klz_25",
  "grid-list--5-columns": "_grid-list--5-columns_17klz_29",
  "grid-list--6-columns": "_grid-list--6-columns_17klz_33",
  "grid-list--7-columns": "_grid-list--7-columns_17klz_37",
  "grid-list--8-columns": "_grid-list--8-columns_17klz_41",
  "grid-list--9-columns": "_grid-list--9-columns_17klz_45",
  "grid-list--10-columns": "_grid-list--10-columns_17klz_49"
};
function n({ children: t, numberOfColumns: l = 2, headerText: s = "" }) {
  l > 10 && (l = 10);
  const _ = `grid-list--${l}-columns`;
  return /* @__PURE__ */ d(c, { children: [
    s !== "" && /* @__PURE__ */ r("h3", { className: [i["grid-list-header"], "grid-list-header"].join(" "), children: s }),
    /* @__PURE__ */ r("ul", { className: [i["grid-list"], i[_]].join(" "), children: t })
  ] });
}
export {
  n as GridList,
  n as default
};
